import { render, staticRenderFns } from "./SolutionSection.vue?vue&type=template&id=34720589&scoped=true&"
import script from "./SolutionSection.vue?vue&type=script&lang=js&"
export * from "./SolutionSection.vue?vue&type=script&lang=js&"
import style0 from "./SolutionSection.vue?vue&type=style&index=0&id=34720589&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34720589",
  null
  
)

export default component.exports